// Regiao de Estudo
// import Fuse from 'fuse.js'
import theapi from '@/api.js'
// import * as turf from '@turf/turf'

import nearestPointToLine from '@turf/nearest-point-on-line';
import length from '@turf/length'
import lineSliceAlong from '@turf/line-slice-along'
import lineSlice from '@turf/line-slice'
// import lineDistance from '@turf/distance'
// import {featureCollection} from '@turf/feature-collection'
import {featureCollection} from '@turf/helpers';

var turf = {
    length,
    lineSliceAlong,
    lineSlice,
    nearestPointToLine,
    lineDistance:length,
    featureCollection
}


var  colorPallete = ['#229331','#F96C0C','#179CF9','#EB00F9','#FFAD00','#5389AB','#ACD72D','#B00047','#A200A9'];

export default function(data) {

    var API_percurso = theapi.percurso;

    var state = {
       runners:[],//{id,color,name}
       trechoRunner:[],// {trechoID,runnerID}
       open:false,
    }


    return {
        state: state,

        //--MUTATIONS
        mutations: {          
            addRunner: function(state, obj) {

                debugger;
                let colorInUse = _.map( state.runners, runner=>runner.color);
                let colorAvaliable =  _.difference(colorPallete, colorInUse);
                let color =  colorAvaliable[Math.floor(Math.random()*colorAvaliable.length)];
                var id = _.uniqueId('runner')
                state.runners.push({id,name:obj,color:color})
            },

            removeRunner: function(state, id) {
         
                  state.trechoRunner = _.filter(state.trechoRunner,item=>item.runnerID != id);
                  state.runners = _.filter(state.runners,runner=>runner.id != id)
            },

            addTrechoToRunner: function(state, {trechoID,runnerID} ) {

                var trechosRunners = [...state.trechoRunner]
                
                //remove trecho element if exists
                _.remove(trechosRunners,item=>item.trechoID == trechoID)
                //remove if runner is false
                if(runnerID==false){
                    _.remove(trechosRunners,item=>item.trechoID == trechoID)
                }
                trechosRunners.push({trechoID,runnerID})
                
                state.trechoRunner = trechosRunners;

            },

            // removeTrechoFromRunner: function(state, obj) {
            //     state.trechoRunner.push(obj)
            // },
            openPlanejamento: function(state,trueOrFalse){
                state.open = trueOrFalse
            }

        },


        //--ACTIONS
        actions: {
           


        },


        //--GETTERS
        getters: {
            corredores: state => state.runners,
            openPlanejamento: state => state.open,
            trechoRunner: state => state.trechoRunner,
            trechosRunnersObject: (state,getters,rootState,rootGetters)=>{

                var trechos = rootGetters.checkpointsCourses;
                var runners = state.runners;
                var trechoRunner = state.trechoRunner;
                
                return _.map(trechoRunner,tr=>{
                    var trecho = _.find(trechos,o=>o.properties.numero==tr.trechoID)
                    var runner = _.find(runners,o=>o.id==tr.runnerID)
                    return {trecho, runner}
                })


            },

            
            // trechoRunnerName: (state,getters) => (trechoID) =>{

            // },

            // kms: state => getRaceInfo(state,"kms"),

            // courses: state => getRaceInfo(state,"course"), //state.races[state.actualRace].courses || false,

            // checkpointsGeoJson: state => getRaceInfo(state,"checkpoints"), //state.races[state.actualRace].checkpoints || false,
            
            // checkpoints: state => getRaceInfo(state,"checkpoints.features"), //state.races[state.actualRace].checkpoints || false,

            // races: state => state.races,

            // currentRace: state => _.get(state.races,`[${state.actualRace}]`, false),
        
            // currentRaceName: state => getRaceInfo(state,"name"),
        
            // currentCourseLeg: state => getRaceInfo(state,`checkpoints.features[${state.actualCourseLeg}]`),

            // pointFromDistance: (state,getters) => (km) =>{
            //     //get the current course
            //     var course = getters.courses
            //     // get point geoJSON
            //     var point = _.along(course,km)
            //     return point
            // }

        },

    }
}

